export default __webpack_public_path__ + "static/media/pancakeswap.285bc1bc.svg";